import { render, staticRenderFns } from "./tDesktop.vue?vue&type=template&id=532e3095&scoped=true&"
import script from "./tDesktop.vue?vue&type=script&lang=ts&"
export * from "./tDesktop.vue?vue&type=script&lang=ts&"
import style0 from "./tDesktop.vue?vue&type=style&index=0&id=532e3095&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "532e3095",
  null
  
)

export default component.exports